import script from "./SliderNewDesktop.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderNewDesktop.vue?vue&type=script&setup=true&lang=js"

import "./SliderNewDesktop.vue?vue&type=style&index=0&id=3ca9f980&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ca9f980"]])

export default __exports__